import React from 'react';
import { DASHBOARD_REPORTS_HEADERS } from '../constants';
import ReportsPharmacyName from './ReportsPharmacyName';
import ReportsTableHeader from './ReportsTableHeader';

const prepareData = (pharmacies) => {
  if (!pharmacies) {
    return [];
  }

  return pharmacies.reduce(
    (summary, order) => {
      const {
        pharmacy_id,
        otc,
        referred_delivery,
        referred_collection,
        total_ever,
        pharmacy_name,
        total,
      } = order;

      summary.push({
        view: {
          pharmacyName: (
            <ReportsPharmacyName
              pharmacyId={pharmacy_id}
              pharmacyName={pharmacy_name}
            />
          ),
          total,
          otc,
          referredDelivery: referred_delivery,
          referredCollection: referred_collection,
          totalEverPercent: `${Math.ceil((total / total_ever) * 100)}%`,
        },
        ID: pharmacy_id,
        route: 'dashboard',
        skipId: true,
      });

      return summary;
    },
    [
      {
        view: {
          pharmacyName: 'Pharmacy',
          total: (
            <ReportsTableHeader
              title="Total"
              orderBy={DASHBOARD_REPORTS_HEADERS.TOTAL}
            />
          ),
          otc: (
            <ReportsTableHeader
              title="OTC"
              orderBy={DASHBOARD_REPORTS_HEADERS.OTC}
            />
          ),
          referredDelivery: (
            <ReportsTableHeader
              title="Referred Delivery"
              orderBy={DASHBOARD_REPORTS_HEADERS.REFERRED_DELIVERY}
            />
          ),
          referredCollection: (
            <ReportsTableHeader
              title="Referred Collection"
              orderBy={DASHBOARD_REPORTS_HEADERS.REFERRED_COLLECTION}
            />
          ),
          totalEverPercent: '% of Total',
        },
        headers: true,
      },
    ],
  );
};

export default prepareData;
